module.exports = __webpack_public_path__ + "assets/img/046c00cb4adbf40f3895aea709948b35.svg";